(() => {
  const mobileViewport = window.matchMedia('(max-width: 749px)');

  // Shopify also attaches click zoom directly to images when image_zoom is "hover".
  // Intercept that click before either the image handler or modal button can run.
  document.addEventListener('click', (event) => {
    if (!mobileViewport.matches || !(event.target instanceof Element)) return;
    if (!event.target.closest('product-info[id^="MainProduct-"] media-gallery .product__modal-opener--image')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  function setupGallery(gallery) {
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    const track = viewer?.querySelector('ul[id^="Slider-Gallery-"]');
    const slides = track ? [...track.children].filter((child) => child.classList.contains('product__media-item')) : [];
    if (!viewer || !slides.length || viewer.querySelector('.mobile-product-media-dots')) return;

    const dots = document.createElement('div');
    dots.className = 'mobile-product-media-dots';
    dots.setAttribute('role', 'group');
    dots.setAttribute('aria-label', gallery.getAttribute('aria-label') || 'Gallery');

    const fitCurrentSlide = (index) => {
      if (!mobileViewport.matches) {
        track.style.removeProperty('height');
        return;
      }
      const media = slides[index]?.querySelector('.product-media-container');
      const height = media?.getBoundingClientRect().height;
      if (height > 0) track.style.height = `${Math.ceil(height)}px`;
    };

    const buttons = slides.map((slide, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `${index + 1} / ${slides.length}`);
      button.setAttribute('aria-controls', track.id);
      button.addEventListener('click', () => {
        if (!mobileViewport.matches) return;
        fitCurrentSlide(index);
        track.scrollTo({
          left: slide.offsetLeft - slides[0].offsetLeft,
          behavior: 'smooth',
        });
      });
      dots.append(button);
      return button;
    });

    const updateDots = (index) => {
      buttons.forEach((button, buttonIndex) => {
        if (buttonIndex === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      fitCurrentSlide(index);
    };

    viewer.insertBefore(dots, viewer.querySelector('.slider-buttons'));
    viewer.addEventListener('slideChanged', (event) => updateDots(event.detail.currentPage - 1));
    updateDots(Math.max(0, (viewer.currentPage || 1) - 1));
    const resizeObserver = new ResizeObserver(() => fitCurrentSlide(Math.max(0, (viewer.currentPage || 1) - 1)));
    slides.forEach((slide) => resizeObserver.observe(slide.querySelector('.product-media-container') || slide));
    mobileViewport.addEventListener('change', () => fitCurrentSlide(Math.max(0, (viewer.currentPage || 1) - 1)));
  }

  function setup(root) {
    root.querySelectorAll('product-info[id^="MainProduct-"] media-gallery').forEach(setupGallery);
  }

  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
